import Logo from '@components/common/logo'

export const TrialBookingPageNavBar = (): JSX.Element => {
  return (
    <nav className="p-4 bg-white shadow">
      <div>
        <Logo
          withText
          alt="Codingal Logo"
          style={{ width: '150px', height: '35px' }}
        />
      </div>
    </nav>
  )
}

export default TrialBookingPageNavBar
